const raw = process.env.REACT_APP_API_BASE || "http://192.168.1.177:5005";
const API_BASE = raw.trim().replace(/\/+$/, "");

if (raw.includes(",")) {
    throw new Error(`REACT_APP_API_BASE is invalid (contains comma): "${raw}"`);
}

export async function adminFetch(path: string, init: RequestInit = {}) {
    const headers = new Headers(init.headers || {});
    headers.set("Accept", "application/json");

    const url = `${API_BASE}${path.startsWith("/") ? path : `/${path}`}`;

    // ✅ DEBUG LOGS
    console.log("[adminFetch] ->", (init.method || "GET"), url, {
        credentials: "include",
        headers: Object.fromEntries(headers.entries()),
    });

    const res = await fetch(url, { ...init, headers, credentials: "include" });

    // ✅ DEBUG LOGS
    console.log("[adminFetch] <-", res.status, res.url);

    return res;
}
